var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3F1ACAAA-D059-4EEF-8099-A41D05DF7647") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-3-3---Actioning-an-Alert",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-3-3---Actioning-an-Alert",
    transform: "translate(-1392.000000, -25.000000)",
    fill: "#292929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/ic_remove",
    transform: "translate(1392.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2212392,0.560578971 C23.4916022,0.830941942 23.5123993,1.25636523 23.2836307,1.55058364 L23.2212392,1.62123914 L12.9519091,11.8909091 L23.2212392,22.160579 C23.5141324,22.4534723 23.5141324,22.928346 23.2212392,23.2212392 C22.9508762,23.4916022 22.5254529,23.5123993 22.2312345,23.2836307 L22.160579,23.2212392 L11.8909091,12.9519091 L1.62123914,23.2212392 C1.32834592,23.5141324 0.85347219,23.5141324 0.560578971,23.2212392 C0.290216,22.9508762 0.269418848,22.5254529 0.498187516,22.2312345 L0.560578971,22.160579 L10.8299091,11.8909091 L0.560578971,1.62123914 C0.267685752,1.32834592 0.267685752,0.85347219 0.560578971,0.560578971 C0.830941942,0.290216 1.25636523,0.269418848 1.55058364,0.498187516 L1.62123914,0.560578971 L11.8909091,10.8299091 L22.160579,0.560578971 C22.4534723,0.267685752 22.928346,0.267685752 23.2212392,0.560578971 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRemove);
export default __webpack_public_path__ + "static/media/ic_remove.f1eb4281e12b2b60e6276f320f152296.svg";
export { ForwardRef as ReactComponent };